import React from 'react'

interface SendToMeragiAPIProps {
    index: number;
    data: any;
    update_response_data: (data: any) => void;
}

function SendToMeragiAPI({ index, data, update_response_data }: SendToMeragiAPIProps) {
    return (
        <div className="w-full rounded-lg">
            <div className="p-4 bg-white rounded-lg border border-gray-200">
                <div className="flex items-center justify-center p-8">
                    <div className="text-center">
                        <svg className="w-16 h-16 mx-auto text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                        </svg>
                        <h3 className="text-lg font-semibold text-gray-700 mb-2">Send to Meragi API</h3>
                        <p className="text-sm text-gray-500">
                            This component will send user data to the Meragi API endpoint.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SendToMeragiAPI
